import { render, staticRenderFns } from "./EiHomeBlock2.vue?vue&type=template&id=44887634&scoped=true&"
import script from "./EiHomeBlock2.vue?vue&type=script&lang=js&"
export * from "./EiHomeBlock2.vue?vue&type=script&lang=js&"
import style0 from "./EiHomeBlock2.vue?vue&type=style&index=0&id=44887634&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44887634",
  null
  
)

export default component.exports